import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { 
    FaTasks, 
    FaSearchLocation, 
    FaSearch,
    FaStoreAlt 
} from 'react-icons/fa'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from '../../../../Button'

import { IndividualSelection } from './IndividualSelection'
import { RegionSelection } from './RegionSelection'
import { FranchiseSelection } from './FranchiseSelection'

import { Container, ContainerButtons } from './style'


export function GeneralSideBarBusinessFilter() {
    const { 
        radioButton, 
        setRadioButton, 
        applyingPreferences,
        franchiseList,
        setFranchiseListCodesSelected,
        allFranchiseListCodes 
    } = useAdministrativeContext()
    const [selectionDetails, setSelectionDetails] = useState(null)

    const dispatch = useDispatch()

    function selectAllBusiness() {
        if(radioButton === 0){
            dispatch({type: '', title: 'Filtrar empresas' })
            return
        }

        setRadioButton(0)
        applyingPreferences(0)
        setFranchiseListCodesSelected(allFranchiseListCodes)
        dispatch({type: '', title: 'Filtrar empresas' })
    }

    function selectIndividualBusiness() {
        setRadioButton(1)
        setSelectionDetails(1)
    }

    function selectRegionBusiness() {
        setRadioButton(2)
        setSelectionDetails(2)
    }

    function selectFranchise () {
        setRadioButton(3)
        setSelectionDetails(3)
    }


    if(selectionDetails !== null)
        return(
            <Container>
                {
                    selectionDetails === 1 ?   
                        <IndividualSelection 
                            setSelectionDetails={setSelectionDetails}
                        /> 

                    : selectionDetails === 2 ?  
                        <RegionSelection 
                            setSelectionDetails={setSelectionDetails}
                        />

                    :   <FranchiseSelection 
                            setSelectionDetails={setSelectionDetails}
                        />
                }
            </Container>
        )


    return(
        <ContainerButtons>

            <Button 
                icon={<FaTasks />}
                background={radioButton === 0 ? '#7A05A7' : '#FFF'}
                color={radioButton === 0 ? '#FFF' : '#7A05A7'}
                onClick={selectAllBusiness}
            >
                Todas as empresas 
            </Button>

            <Button 
                icon={<FaSearch />}
                background={radioButton === 1 ? '#7A05A7' : '#FFF'}
                color={radioButton === 1 ? '#FFF' : '#7A05A7'}
                onClick={selectIndividualBusiness}
            >
                Busca individual
            </Button>

            <Button 
                icon={<FaSearchLocation />}
                background={radioButton === 2 ? '#7A05A7' : '#FFF'}
                color={radioButton === 2 ? '#FFF' : '#7A05A7'}
                onClick={selectRegionBusiness}
            >
                Busca por região 
            </Button>

            {
                franchiseList.length > 0 &&
                <Button 
                    icon={<FaStoreAlt />}
                    background={radioButton === 3 ? '#7A05A7' : '#FFF'}
                    color={radioButton === 3 ? '#FFF' : '#7A05A7'}
                    onClick={selectFranchise}
                >
                    Busca por franquia
                </Button>
            }

        </ContainerButtons>
    )
}
